/* 法正（字孝直） */
import { SG } from '../../core/kit.ts';
import { defineHero, hook, U } from '../define.ts';

export default defineHero({
  id: 'fazheng', name: '法正', sub: '字孝直', faction: 'shu', role: '法師', weapon: 'staff',
  look: { head: 'guan', robe: true, eye: 'narrow', beard: 'goatee', fx: '#ff9a6a', c: { cloth: '#4a3a2a', sleeve: '#4a3a2a', armor: '#c9a24e', pole: '#3a2a20' } },
  skills: [
    ['奇謀', 'bolt', '射出氣彈，造成 {90/146/202/258} 傷害。', { el: 'shadow' }],
    ['恩怨', 'hook', '鎖住一名敵人：定身 1 秒，{2/2.5/3/3.5} 秒內法正對他的傷害 +20%。', { x: { k: 'grudge', dur: [2, 2.5, 3, 3.5], amp: 20, root: 1 }, aim: U(500), cd: 14, mp: [70, 80, 90, 100], el: 'shadow' }],
    ['睚眥必報', 'passive', '被敵將打傷後 5 秒內，下一個打中那名敵將的技能 +{10/15/20/25}% 傷害。', { pv: {}, sig: 'revenge', amp: [10, 15, 20, 25], ready: (u, w) => !!(u.revenge && u.revenge.until > w.t) }],
    ['定軍山之計', 'thunder', '指定一處落下天雷，造成 {360/540/720} 傷害並暈眩 0.8 秒；命中武將時全隊獲得該處視野 4 秒。', { col: '#ff9a6a', sig: 'dingjun' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 法正「恩怨」：定身並標記
    grudge(u, a, X) {
      const t = this.xPick(u, a.pt, 150);
      if (!t) { this.xRefund(u, a); return; }
      this.applyCC(u, t, { root: X.root });
      t.grudge = { by: u, until: this.t + X.dur, amp: X.amp };
      this.fx({ k: 'spark', x: t.x, y: t.y - 40, col: '#b07cff' });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 恩怨：對被鎖定的人 +20%；睚眥必報：下一個技能打中傷害來源時加傷，被敵將打到時記住對方
    hook('damage.before', 70, function (c) {
      const t = c.t, own0 = c.own, o = c.o;
      if (t.grudge && t.grudge.by === own0 && t.grudge.until > this.t) c.a *= 1 + t.grudge.amp / 100;
      if (own0.revenge && own0.revenge.id === t.id && own0.revenge.until > this.t && o && (o.spell || o.sk)) { c.a *= 1 + own0.revenge.amp / 100; own0.revenge = null; if (own0.human) this.dmgEvents.push({ x: t.x, y: t.y - 60, text: '睚眥必報', team: t.team, src: own0.id, tgt: t.id }); }
      if (t.sg && t.sg.revenge && own0.kind === 'hero' && own0.team !== t.team) t.revenge = { id: own0.id, until: this.t + 5, amp: t.sg.revenge.v('amp') };
    }),
    // 定軍山之計：打中武將就給全隊該處視野 4 秒
    hook('damage.after', 30, function (c, lost) {
      const act0 = c.act, t = c.t, own0 = c.own;
      if (act0 && lost > 0 && own0.team !== t.team && act0.sk.sig === 'dingjun' && t.kind === 'hero' && !act0.ward) { act0.ward = 1; this.units.push(SG._sim.unit({ kind: 'ward', team: own0.team, x: t.x, y: t.y, life: 4, r: 10, hp: 1, maxHp: 1 })); }
    }),
  ],
  // 電腦什麼時候放這招
  ai: {
    grudge: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 480,
  },
});
